import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const TermsAndConditions = () => {
  return (
    <div className="min-h-screen bg-dark-bg py-12 px-6">
      <div className="max-w-4xl mx-auto">
        <Link 
          to="/" 
          className="inline-flex items-center gap-2 text-cream-gold hover:text-cream-gold-light transition-colors mb-8"
        >
          <ArrowLeft className="w-5 h-5" />
          Back to Home
        </Link>

        <h1 className="text-4xl md:text-5xl font-bold text-cream-gold mb-4">
          Terms & Conditions
        </h1>
        <p className="text-cream-gold-light/60 mb-8">Last updated: January 2025</p>

        <div className="space-y-8 text-cream-gold-light/80 leading-relaxed">
          <section>
            <h2 className="text-2xl font-bold text-cream-gold mb-4">1. Introduction</h2>
            <p>
              Welcome to Evox Media. These Terms and Conditions govern your use of our website and services. By accessing or using our services, you agree to be bound by these terms. If you do not agree with any part of these terms, please do not use our services.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-cream-gold mb-4">2. Services</h2>
            <p className="mb-4">
              Evox Media provides content creation and management services including but not limited to:
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Content strategy and planning</li>
              <li>Video production and editing</li>
              <li>Social media management</li>
              <li>Channel optimization</li>
              <li>Performance analytics</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-cream-gold mb-4">3. Client Responsibilities</h2>
            <p className="mb-4">As a client, you agree to:</p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Provide accurate and complete information</li>
              <li>Grant necessary access to platforms and accounts</li>
              <li>Respond to requests for feedback in a timely manner</li>
              <li>Pay all fees as agreed upon in the service agreement</li>
              <li>Maintain confidentiality of proprietary methods and strategies shared</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-cream-gold mb-4">4. Payment Terms</h2>
            <p className="mb-4">
              Payment terms will be outlined in individual service agreements. Generally:
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Services require advance payment or deposits</li>
              <li>Invoices are due within 15 days of issuance unless otherwise stated</li>
              <li>Late payments may result in service suspension</li>
              <li>Refund policies are outlined in individual contracts</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-cream-gold mb-4">5. Intellectual Property</h2>
            <p className="mb-4">
              Upon full payment, you will own the rights to the final delivered content. However:
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Evox Media retains rights to use work samples in portfolios and marketing</li>
              <li>Raw footage and working files remain property of Evox Media</li>
              <li>Any pre-existing materials, templates, or methodologies remain our property</li>
              <li>You may not resell or redistribute our deliverables to third parties</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-cream-gold mb-4">6. Confidentiality</h2>
            <p>
              Both parties agree to maintain confidentiality of proprietary information shared during the course of business. This includes but is not limited to business strategies, financial information, and creative concepts.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-cream-gold mb-4">7. Limitation of Liability</h2>
            <p className="mb-4">
              Evox Media will not be liable for:
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Platform algorithm changes affecting content performance</li>
              <li>Third-party platform outages or policy changes</li>
              <li>Indirect, incidental, or consequential damages</li>
              <li>Loss of revenue or business opportunities</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-cream-gold mb-4">8. Termination</h2>
            <p>
              Either party may terminate services with 30 days written notice. Upon termination, client is responsible for payment of all work completed to date. Any advance payments for uncompleted work will be refunded on a pro-rata basis.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-cream-gold mb-4">9. Governing Law</h2>
            <p>
              These terms shall be governed by and construed in accordance with the laws of the jurisdiction in which Evox Media operates, without regard to conflict of law principles.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-cream-gold mb-4">10. Changes to Terms</h2>
            <p>
              We reserve the right to modify these terms at any time. Changes will be effective immediately upon posting to our website. Continued use of our services after changes constitutes acceptance of modified terms.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-cream-gold mb-4">11. Contact Information</h2>
            <p>
              For questions regarding these Terms and Conditions, please contact us at:
            </p>
            <p className="mt-2">
              Email: <a href="mailto:business@evoxmedia.co" className="text-cream-gold hover:text-cream-gold-light">business@evoxmedia.co</a><br />
              Phone: <a href="tel:+919840084468" className="text-cream-gold hover:text-cream-gold-light">+91-9840084468</a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;